
export enum BudgetFeeStatus {
    Pending = 0,
    Remitted = 1,
    Paid = 2,
    Returned = 3,
    Recalculated = 4,
    Out = 5,
    CardPaymentError = 5,
}

export const BudgetFeeStatusLiteral = [
    'Pendiente',
    'Remesada',
    'Pagada',
    'Devuelta',
    'Recalculada',
    'Baja',
    'Error en el pago con tarjeta',
];

export enum BudgetFeePaymentMethod {
    Cash = 1,
    Card = 2,
    DirectDebit = 3,
    SendWireTransfer = 4,
}

export const BudgetFeePaymentMethodLiteral = [
    'No seleccionado',
    'Efectivo',
    'Tarjeta',
    'Domiciliado',
    'Transferencia',
];

export interface BudgetFeeInterface {
    id?: string;
    price?: number;
    remittanceDate?: string;
    paymentDate?: string;
    collectionDate?: string;
    status?: BudgetFeeStatus;
    paymentMethod?: BudgetFeePaymentMethod | string;
    budget?: string;
    editing?: boolean;
}

export class BudgetFee implements BudgetFeeInterface {
    public id?: string;
    public price?: number;
    public remittanceDate?: string;
    public paymentDate?: string;
    public collectionDate?: string;
    public status?: BudgetFeeStatus;
    public paymentMethod?: BudgetFeePaymentMethod | string;
    public budget?: string;
    public editing?: boolean;

    constructor() {
        this.price = 0;
    }
}
